import { twMerge } from 'tailwind-merge';
import { FC, FunctionComponent, SVGProps } from 'react';

interface CategoryButtonProps {
  title: string;
  Image: FunctionComponent<SVGProps<SVGSVGElement>>;
  ActiveImage: FunctionComponent<SVGProps<SVGSVGElement>>;
  isActive: boolean;
  onClick: () => void;
  margin?: number;
  className?: string;
  comingSoon?: boolean;
}

const CategoryButton: FC<CategoryButtonProps> = ({
  title,
  Image,
  ActiveImage,
  isActive,
  onClick,
  margin,
  comingSoon = false,
}) => {
  return (
    <button
      disabled={comingSoon}
      type="button"
      className={twMerge(
        `box-border flex max-h-[124px] min-w-fit flex-grow items-center justify-center rounded-xl border-4 border-ph-gray-white-transparent bg-cover bg-center bg-no-repeat`,
        isActive ? 'border-4 border-ph-primary-violet bg-[#A046D350]' : '',
        'group relative overflow-hidden',
        !comingSoon && 'hover:border-ph-primary-violet hover:bg-[#A046D350] lg:hover:border-4',
      )}
      onClick={onClick}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#1E1A2E]" />
      <div className="relative flex h-full w-full flex-col items-center justify-end py-5 text-center">
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex max-w-[90px] items-center justify-center" style={{ width: '100px', height: 'auto' }}>
            {isActive ? (
              <ActiveImage style={{ margin: margin }} />
            ) : (
              <div className="flex flex-col justify-center">
                {comingSoon && (
                  <span className="text-xxs mx-auto min-w-[91px] px-2 text-sm font-bold text-ph-orange-burned">
                    COMING SOON
                  </span>
                )}
                <Image className={twMerge(!comingSoon && 'group-hover:hidden')} />
                {!comingSoon && <ActiveImage className="hidden group-hover:block" style={{ margin: margin }} />}
              </div>
            )}
          </div>
        </div>
        <h2 className="font-obvia text-xs font-extrabold text-ph-gray-white 2xl:text-base">{title}</h2>
      </div>
    </button>
  );
};

export default CategoryButton;
